import { render, staticRenderFns } from "./VTText.vue?vue&type=template&id=88701f88&scoped=true&"
import script from "./VTText.vue?vue&type=script&lang=js&"
export * from "./VTText.vue?vue&type=script&lang=js&"
import style0 from "./VTText.vue?vue&type=style&index=0&id=88701f88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88701f88",
  null
  
)

export default component.exports